<template>
  <div class="container">
    <account-tab-menu/>

    <div class="row justify-content-end my-3 pr-3">
      <div class="col-auto border pointer" @click="changeLanguage('th')">TH</div>
      <div class="col-auto border pointer" @click="changeLanguage('en')">EN</div>
    </div>


    <div class="row align-items-center" v-if="lang === 'th'">
      <div class="col">
        <div class="mb-5">
          <h2>นโยบายการคุ้มครองข้อมูลส่วนบุคคล (Privacy Policy)</h2>
        </div>
        <div class="mb-3"><b>1. บทนำ</b></div>
        <div class="mb-3">
          SiamSquared Technologies (Thailand) Co., Ltd. และ บริษัทในเครือ
          (ต่อไปในนโยบายนี้เรียกว่า “S2” หรือ “องค์กร” หรือ “บริษัทฯ”)
          ตระหนักถึงความสำคัญของข้อมูลส่วนบุคคลและข้อมูลอื่นอันเกี่ยวกับท่าน
          (รวมเรียกว่า “ข้อมูล”) เพื่อให้ท่านสามารถเชื่อมั่นได้ว่า S2
          มีความโปร่งใสและความรับผิดชอบในการเก็บรวบรวม
          ใช้หรือเปิดเผยข้อมูลของท่านตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล
          พ.ศ. 2562 (“กฎหมายคุ้มครองข้อมูลส่วนบุคคล”)
          รวมถึงกฎหมายอื่นที่เกี่ยวข้อง นโยบายการคุ้มครองข้อมูลส่วนบุคคล
          (“นโยบาย”)
          นี้จึงได้ถูกจัดทำขึ้นเพื่อชี้แจงแก่ท่านถึงรายละเอียดเกี่ยวกับการเก็บรวบรวม
          ใช้หรือเปิดเผย (รวมเรียกว่า “ประมวลผล”)
          ข้อมูลส่วนบุคคลซึ่งดำเนินการโดย S2
          รวมถึงเจ้าหน้าที่และบุคคลที่เกี่ยวข้องผู้ดำเนินการแทนหรือในนามของ S2
          โดยมีเนื้อหาสาระดังต่อไปนี้
        </div>
        <div class="mb-3"><b>2. ขอบเขตการบังคับใช้นโยบาย</b></div>
        <div class="mb-3">
          นโยบายนี้ใช้บังคับกับข้อมูลส่วนบุคคลของบุคคลซึ่งมีความสัมพันธ์กับ S2
          ในปัจจุบันและที่อาจมีในอนาคต ซึ่งถูกประมวลผลข้อมูลส่วนบุคคลโดย S2
          เจ้าหน้าที่ พนักงานตามสัญญา หน่วยธุรกิจ
          หรือหน่วยงานรูปแบบอื่นที่ดำเนินการโดย S2
          และรวมถึงคู่สัญญาหรือบุคคลภายนอกที่ประมวลผลข้อมูลส่วนบุคคลแทนหรือในนามของ
          S2 (“ผู้ประมวลผลข้อมูลส่วนบุคคล”) ภายใต้ผลิตภัณฑ์และบริการต่าง ๆ เช่น
          เว็บไซต์ ระบบ แอปพลิเคชัน เอกสาร
          หรือบริการในรูปแบบอื่นที่ควบคุมดูแลโดย S2 (รวมเรียกว่า “บริการ”)
        </div>
        <div class="mb-3">
          บุคคลมีความสัมพันธ์กับ S2 ตามความในวรรคแรก รวมถึง<br/>
          1) ลูกค้าบุคคลธรรมดา<br/>
          2) เจ้าหน้าที่หรือผู้ปฏิบัติงาน ลูกจ้าง<br/>
          3) คู่ค้าและผู้ให้บริการซึ่งเป็นบุคคลธรรมดา<br/>
          4) กรรมการ ผู้รับมอบอำนาจ ผู้แทน ตัวแทน ผู้ถือหุ้น ลูกจ้าง
          หรือบุคคลอื่นที่มีความสัมพันธ์ในรูปแบบเดียวกันของนิติบุคคลที่มีความสัมพันธ์กับ
          S2<br/>
          5) ผู้ใช้งานผลิตภัณฑ์หรือบริการของ S2 <br/>
          6) ผู้เข้าชมหรือใช้งานเว็บไซต์ https://stockradars.co รวมทั้งระบบ
          แอปพลิเคชัน อุปกรณ์ หรือช่องทางการสื่อสารอื่นซึ่งควบคุมดูแลโดย S2<br/>
          7) บุคคลอื่นที่ S2 เก็บรวบรวมข้อมูลส่วนบุคคล เช่น ผู้สมัครงาน
          ครอบครัวของเจ้าหน้าที่ ผู้ค้ำประกัน ผู้รับประโยชน์ในกรมธรรม์ประกันภัย
          เป็นต้น ข้อ 1) ถึง 6) เรียกรวมกันว่า “ท่าน”
        </div>
        <div class="mb-3">
          นอกจากนโยบายฉบับนี้แล้ว S2
          อาจกำหนดให้มีคำประกาศเกี่ยวกับความเป็นส่วนตัว (“ประกาศ”)
          สำหรับผลิตภัณฑ์หรือบริการของ S2
          เพื่อชี้แจงให้เจ้าของข้อมูลส่วนบุคคลซึ่งเป็นผู้ใช้บริการได้ทราบถึงข้อมูลส่วนบุคคลที่ถูกประมวลผล
          วัตถุประสงค์และเหตุผลอันชอบด้วยกฎหมายในการประมวลผล
          ระยะเวลาในการเก็บรักษาข้อมูลส่วนบุคคล
          รวมถึงสิทธิในข้อมูลส่วนบุคคลที่เจ้าของข้อมูลส่วนบุคคลพึงมีในผลิตภัณฑ์หรือบริการนั้นเป็นการเฉพาะเจาะจง
          ทั้งนี้
          ในกรณีที่มีความขัดแย้งกันในสาระสำคัญระหว่างความในประกาศเกี่ยวกับความเป็นส่วนตัวและนโยบายนี้
          ให้ถือตามความในประกาศเกี่ยวกับความเป็นส่วนตัวของบริการนั้น
        </div>
        <div class="mb-3"><b>3. คำนิยาม</b></div>
        <div class="mb-3">
          - <b>S2 </b>หมายถึง บริษัท สยามสแควร์ เทคโนโลยี (ประเทศไทย) จำกัด
          และบริษัทในเครือ<br/>
          - <b>ข้อมูลส่วนบุคคล</b> หมายถึง ข้อมูลเกี่ยวกับบุคคลธรรมดา
          ซึ่งทำให้สามารถระบุตัวบุคคลนั้นได้ ไม่ว่าทางตรงหรือทางอ้อม
          แต่ไม่รวมถึงข้อมูลของผู้ถึงแก่กรรมโดยเฉพาะ<br/>
          - <b>ข้อมูลส่วนบุคคลอ่อนไหว</b> หมายถึง
          ข้อมูลส่วนบุคคลตามที่ถูกบัญญัติไว้ในมาตรา 26
          แห่งพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 ซึ่งได้แก่
          ข้อมูลเชื้อชาติ เผ่าพันธุ์ ความคิดเห็นทางการเมือง ความเชื่อในลัทธิ
          ศาสนาหรือปรัชญา พฤติกรรมทางเพศ ประวัติอาชญากรรม ข้อมูลสุขภาพ ความพิการ
          ข้อมูลสหภาพแรงงาน ข้อมูลพันธุกรรม ข้อมูลชีวภาพ
          หรือข้อมูลอื่นใดซึ่งกระทบต่อเจ้าของข้อมูลส่วนบุคคลในทำนองเดียวกันตามที่คณะกรรมการคุ้มครองข้อมูลส่วนบุคคลประกาศกำหนด<br/>
          - <b>การประมวลผลข้อมูลส่วนบุคคล</b> หมายถึง การดำเนินการใด ๆ
          กับข้อมูลส่วนบุคคล เช่น เก็บรวบรวม บันทึก สำเนา จัดระเบียบ เก็บรักษา
          ปรับปรุง เปลี่ยนแปลง ใช้ กู้คืน เปิดเผย ส่งต่อ เผยแพร่ โอน รวม ลบ
          ทำลาย เป็นต้น<br/>
          - <b>เจ้าของข้อมูลส่วนบุคคล</b> หมายถึง
          บุคคลธรรมดาซึ่งเป็นเจ้าของข้อมูลส่วนบุคคลที่ S2 เก็บรวบรวม ใช้
          หรือเปิดเผย - <b>เผู้ควบคุมข้อมูลส่วนบุคคล</b> หมายถึง
          บุคคลหรือนิติบุคคลซึ่งมีอำนาจหน้าที่ตัดสินใจเกี่ยวกับการเก็บรวบรวม ใช้
          หรือเปิดเผยข้อมูลส่วนบุคคล<br/>
          - <b>ผู้ประมวลผลข้อมูลส่วนบุคคล</b> หมายถึง
          บุคคลหรือนิติบุคคลซึ่งดำเนินการเกี่ยวกับการเก็บรวบรวม ใช้
          หรือเปิดเผยข้อมูลส่วนบุคคลตามคำสั่งหรือในนามของผู้ควบคุมข้อมูลส่วนบุคคล
          ทั้งนี้
          บุคคลหรือนิติบุคคลซึ่งดำเนินการดังกล่าวไม่เป็นผู้ควบคุมข้อมูลส่วนบุคคล<br/>
        </div>
        <div class="mb-3">
          <b>4. แหล่งที่มาของข้อมูลส่วนบุคคลที่ S2 เก็บรวบรวม</b>
        </div>
        <div>
          S2 เก็บรวบรวมหรือได้มาซึ่งข้อมูลส่วนบุคคลประเภทต่าง ๆ
          จากแหล่งข้อมูลดังต่อไปนี้
        </div>
        <div class="mb-3">
          1) ข้อมูลส่วนบุคคลที่ S2
          เก็บรวบรวมจากเจ้าของข้อมูลส่วนบุคคลโดยตรงในช่องทางให้บริการต่าง ๆ เช่น
          ขั้นตอนการสมัคร ลงทะเบียน สมัครงาน ลงนามในสัญญา เอกสาร
          ทำแบบสำรวจหรือใช้งานผลิตภัณฑ์ บริการ
          หรือช่องทางให้บริการอื่นที่ควบคุมดูแลโดย S2
          หรือเมื่อเจ้าของข้อมูลส่วนบุคคลติดต่อสื่อสารกับ S2 ณ
          ที่ทำการหรือผ่านช่องทางติดต่ออื่นที่ควบคุมดูแลโดย S2 เป็นต้น<br/>

          2) ข้อมูลที่ S2
          เก็บรวบรวมจากการที่เจ้าของข้อมูลส่วนบุคคลเข้าใช้งานเว็บไซต์
          ผลิตภัณฑ์หรือบริการอื่น ๆ ตามสัญญาหรือตามพันธกิจ เช่น
          การติดตามพฤติกรรมการใช้งานเว็บไซต์ ผลิตภัณฑ์หรือบริการของ S2
          ด้วยการใช้คุกกี้ (Cookies)
          หรือจากซอฟต์แวร์บนอุปกรณ์ของเจ้าของข้อมูลส่วนบุคคล เป็นต้น<br/>

          3) ข้อมูลส่วนบุคคลที่ S2
          เก็บรวบรวมจากแหล่งอื่นนอกจากเจ้าของข้อมูลส่วนบุคคล
          โดยที่แหล่งข้อมูลดังกล่าวมีอำนาจหน้าที่ มีเหตุผลที่ชอบด้วยกฎหมาย
          หรือได้รับความยินยอมจากเจ้าของข้อมูลส่วนบุคคลแล้วในการเปิดเผยข้อมูลแก่
          S2 เช่น
          การเชื่อมโยงบริการดิจิทัลของหน่วยงานของรัฐในการให้บริการเพื่อประโยชน์สาธารณะแบบเบ็ดเสร็จแก่เจ้าของข้อมูลส่วนบุคคลเอง
          การรับข้อมูลส่วนบุคคลจากหน่วยงานของรัฐแห่งอื่นในฐานะที่ S2
          มีหน้าที่ตามพันธกิจในการดำเนินการจัดให้มีศูนย์แลกเปลี่ยนข้อมูลกลาง
          เพื่อสนับสนุนการดำเนินการของหน่วยงานของรัฐในการให้บริการประชาชนผ่านระบบดิจิทัล
          รวมถึงจากความจำเป็นเพื่อให้บริการตามสัญญาที่อาจมีการแลกเปลี่ยนข้อมูลส่วนบุคคลกับหน่วยงานคู่สัญญาได้
          นอกจากนี้
          ยังหมายความรวมถึงกรณีที่ท่านเป็นผู้ให้ข้อมูลส่วนบุคคลของบุคคลภายนอกแก่
          S2 ดังนี้ ท่านมีหน้าที่รับผิดชอบในการแจ้งรายละเอียดตามนโยบายนี้
          หรือประกาศของผลิตภัณฑ์หรือบริการ ตามแต่กรณี ให้บุคคลดังกล่าวทราบ
          ตลอดจนขอความยินยอมจากบุคคลนั้นหากเป็นกรณีที่ต้องได้รับความยินยอมในการเปิดเผยข้อมูลแก่
          S2 ทั้งนี้
          ในกรณีที่เจ้าของข้อมูลส่วนบุคคลปฏิเสธไม่ให้ข้อมูลที่มีความจำเป็นในการให้บริการของ
          S2 อาจเป็นผลให้ S2
          ไม่สามารถให้บริการนั้นแก่เจ้าของข้อมูลส่วนบุคคลดังกล่าวได้ทั้งหมดหรือบางส่วน
        </div>
        <div class="mb-3">
          <b>5. จุดประสงค์ในการเก็บรวบรวมข้อมูลส่วนบุคคล</b>
        </div>
        <div class="mb-3">
          S2
          พิจารณากำหนดจุดประสงค์ในการเก็บรวบรวมข้อมูลส่วนบุคคลของท่านตามความเหมาะสมและตามบริบทของการให้บริการ
          ทั้งนี้ จุดประสงค์ในการเก็บรวบรวมข้อมูลส่วนบุคคลที่ S2 ใช้ ประกอบด้วย
        </div>
        <div class="container">
          <div class="row border border-dark">
            <div class="col border border-dark">
              <div class="text-center">
                <b>จุดประสงค์ในการเก็บรวบรวมข้อมูล</b>
              </div>
            </div>
            <div class="col border border-dark">
              <div class="text-center"><b>รายละเอียด</b></div>
            </div>
          </div>

          <div class="row border border-dark">
            <div class="col border border-dark">
              <div>
                เพื่อการดำเนินภารกิจเพื่อประโยชน์สาธารณะหรือการใช้อำนาจรัฐที่ S2
                ได้รับ
              </div>
            </div>
            <div class="col border border-dark">
              <div>
                เพื่อให้ S2
                สามารถใช้อำนาจรัฐและดำเนินภารกิจเพื่อประโยชน์สาธารณะตามพันธกิจ
                S2 ซึ่งกำหนดไว้ตามกฎหมาย เช่น <br/>
                - พระราชกฤษฎีกาจัดตั้งสำนักงานพัฒนารัฐบาลดิจิทัล (องค์การมหาชน)
                พ.ศ. 2561 <br/>
                - พระราชบัญญัติการบริหารงานและการให้บริการภาครัฐผ่านระบบดิจิทัล
                พ.ศ. 2562 รวมถึง กฎ ระเบียบ คำสั่งและมติคณะรัฐมนตรีที่เกี่ยวข้อง
                เป็นต้น
              </div>
            </div>
          </div>
          <div class="row border border-dark">
            <div class="col border border-dark">
              <div>เพื่อการปฏิบัติหน้าที่ตามกฎหมาย</div>
            </div>
            <div class="col border border-dark">
              <div>
                เพื่อให้ S2 สามารถปฏิบัติตามที่กฎหมายที่ควบคุม S2 เช่น <br/>
                -
                การเก็บรวบรวมข้อมูลจราจรทางคอมพิวเตอร์ตามพระราชบัญญัติว่าด้วยการกระทำความผิดเกี่ยวกับคอมพิวเตอร์
                พ.ศ. 2560 <br/>
                - พระราชบัญญัติข้อมูลข่าวสารของราชการ พ.ศ. 2540 <br/>
                - พระราขบัญญัติองค์การมหาชน พ.ศ. 2542 <br/>
                - กฎหมายว่าด้วยภาษีอากร รวมถึง การดำเนินการตามคำสั่งศาล เป็นต้น
              </div>
            </div>
          </div>
          <div class="row border border-dark">
            <div class="col border border-dark">
              <div>เป็นการจำเป็นเพื่อประโยชน์โดยชอบด้วยกฎหมาย</div>
            </div>
            <div class="col border border-dark">
              <div>
                เพื่อประโยชน์โดยชอบด้วยกฎหมายของ S2 และของบุคคลอื่น
                ซึ่งประโยชน์ดังกล่าวมีความสำคัญไม่น้อยไปกว่าสิทธิขั้นพื้นฐานในข้อมูลส่วนบุคคลของเจ้าของข้อมูลส่วนบุคคล
                เช่น เพื่อการรักษาความปลอดภัยอาคารสถานที่ของ S2
                หรือการประมวลผลข้อมูลส่วนบุคคลเพื่อกิจการภายในของ S2 เป็นต้น
              </div>
            </div>
          </div>
          <div class="row border border-dark">
            <div class="col border border-dark">
              <div>เพื่อการปฏิบัติตามสัญญา</div>
            </div>
            <div class="col border border-dark">
              <div>
                เพื่อให้ S2 สามารถปฏิบัติหน้าที่ตามสัญญา
                หรือดำเนินการอันเป็นความจำเป็นต่อการเข้าทำสัญญาซึ่งท่านเป็นคู่สัญญากับ
                S2 เช่น การจ้างงาน จ้างทำของ
                การทำบันทึกข้อตกลงความร่วมมือหรือสัญญาในรูปแบบอื่น เป็นต้น
              </div>
            </div>
          </div>
          <div class="row border border-dark">
            <div class="col border border-dark">
              <div>
                เพื่อการจัดทำเอกสารประวัติศาสตร์ วิจัย หรือสถิติที่สำคัญ
              </div>
            </div>
            <div class="col border border-dark">
              <div>
                เพื่อให้ S2 สามารถจัดทำหรือสนับสนุนการจัดทำเอกสารประวัติศาสตร์
                วิจัยหรือสถิติตามที่ S2 อาจได้รับมอบหมาย เช่น
                การจัดทำสถิติการใช้บริการดิจิทัลภาครัฐ
                งานติดตามการดำเนินนโยบายรัฐบาลดิจิทัล เป็นต้น
              </div>
            </div>
          </div>
          <div class="row border border-dark mb-3">
            <div class="col border border-dark">
              <div>ความยินยอมของท่าน</div>
            </div>
            <div class="col border border-dark">
              <div>
                เพื่อการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคล ในกรณีที่ S2
                จำเป็นต้องได้รับความยินยอมจากท่าน
                โดยได้มีการแจ้งวัตถุประสงค์ของการเก็บรวบรวม ใช้
                หรือเปิดเผยข้อมูลส่วนบุคคลก่อนการขอความยินยอมแล้ว เช่น
                การเก็บรวบรวมข้อมูลส่วนบุคคลอ่อนไหวด้วยวัตถุประสงค์ที่ไม่เป็นไปตามข้อยกเว้นมาตรา
                24 หรือ 26 แห่งพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562
                หรือการนำเสนอ ประชาสัมพันธ์ผลิตภัณฑ์
                และบริการของคู่สัญญาหรือพันธมิตรทางธุรกิจแก่ท่าน เป็นต้น
              </div>
            </div>
          </div>
        </div>

        <div class="mb-3">
          ในกรณีที่ S2
          มีความจำเป็นต้องเก็บรวบรวมข้อมูลส่วนบุคคลของท่านเพื่อการปฏิบัติตามสัญญา
          การปฏิบัติหน้าที่ตามกฎหมายหรือเพื่อความจำเป็นในการเข้าทำสัญญา
          หากท่านปฏิเสธไม่ให้ข้อมูลส่วนบุคคลหรือ
          คัดค้านการดำเนินการประมวลผลตามวัตถุประสงค์ของกิจกรรม อาจมีผลทำให้ S2
          ไม่สามารถดำเนินการหรือให้บริการตามที่ท่านร้องขอได้ทั้งหมดหรือบางส่วน
        </div>
        <div class="mb-3">
          <b>6. ประเภทของข้อมูลส่วนบุคคลที่ S2 เก็บรวบรวม</b>
        </div>
        <div class="mb-3">
          S2 อาจเก็บรวบรวมหรือได้มาซึ่งข้อมูลดังต่อไปนี้
          ซึ่งอาจรวมถึงข้อมูลส่วนบุคคลของท่าน ทั้งนี้
          ขึ้นอยู่กับบริการที่ท่านใช้หรือบริบทความสัมพันธ์ที่ท่านมีกับ S2
          รวมถึงข้อพิจารณาอื่นที่มีผลกับการเก็บรวบรวมข้อมูลส่วนบุคคล
          โดยประเภทของข้อมูลที่ระบุไว้ดังต่อไปนี้เป็นเพียงกรอบการเก็บรวบรวมข้อมูลส่วนบุคคลของ
          S2 เป็นการทั่วไป ทั้งนี้
          เฉพาะข้อมูลที่เกี่ยวข้องกับผลิตภัณฑ์หรือบริการที่ท่านใช้งานหรือมีความสัมพันธ์ด้วยเท่านั้นที่จะมีผลบังคับใช้
        </div>
        <div class="container">
          <div class="row border border-dark">
            <div class="col border border-dark">
              <div class="text-center">
                <b>ประเภทของข้อมูลส่วนบุคคล</b>
              </div>
            </div>
            <div class="col border border-dark">
              <div class="text-center"><b>รายละเอียด</b></div>
            </div>
          </div>

          <div class="row border border-dark">
            <div class="col border border-dark">
              <div>ข้อมูลเฉพาะตัวบุคคล</div>
            </div>
            <div class="col border border-dark">
              <div>
                ข้อมูลระบุชื่อเรียกของท่านหรือข้อมูลจากเอกสารราชการที่ระบุข้อมูลเฉพาะตัวของท่าน
                เช่น คำนำหน้าชื่อ ชื่อ นามสกุล ชื่อกลาง ชื่อเล่น ลายมือชื่อ
                เลขที่บัตรประจำตัวประชาชน สัญชาติ เลขที่หนังสือเดินทาง
                ข้อมูลทะเบียนบ้าน หมายเลขประจำตัวผู้ประกันตน หมายเลขประกันสังคม
                เป็นต้น
              </div>
            </div>
          </div>

          <div class="row border border-dark">
            <div class="col border border-dark">
              <div>ข้อมูลเกี่ยวกับคุณลักษณะของบุคคล</div>
            </div>
            <div class="col border border-dark">
              <div>
                ข้อมูลรายละเอียดเกี่ยวกับตัวท่าน เช่น วันเดือนปีเกิด เพศ ส่วนสูง
                น้ำหนัก อายุ สถานภาพการสมรส สถานภาพการเกณฑ์ทหาร รูปถ่าย ภาษาพูด
                ข้อมูลพฤติกรรม ความชื่นชอบ เป็นต้น
              </div>
            </div>
          </div>

          <div class="row border border-dark">
            <div class="col border border-dark">
              <div>ข้อมูลสำหรับการติดต่อ</div>
            </div>
            <div class="col border border-dark">
              <div>
                ข้อมูลเพื่อการติดต่อท่าน เช่น เบอร์โทรศัพท์บ้าน
                เบอร์โทรศัพท์เคลื่อนที่ หมายเลขโทรสาร อีเมล
                ที่อยู่ทางไปรษณีย์บ้าน ชื่อผู้ใช้งานในสังคมออนไลน์ (Line ID, MS
                Teams) แผนที่ตั้งของที่พัก เป็นต้น
              </div>
            </div>
          </div>

          <div class="row border border-dark">
            <div class="col border border-dark">
              <div>ข้อมูลเกี่ยวกับการทำงานและการศึกษา</div>
            </div>
            <div class="col border border-dark">
              <div>
                รายละเอียดการจ้างงาน รวมถึงประวัติการทำงานและประวัติการศึกษา
                เช่น อาชีพ ยศ ตำแหน่ง หมายเลขประจำตัวผู้เสียภาษี ประวัติการทำงาน
                ข้อมูลเงินเดือน หมายเลขบัญชีธนาคาร สถาบันการศึกษา วุฒิการศึกษา
                เป็นต้น
              </div>
            </div>
          </div>

          <div class="row border border-dark">
            <div class="col border border-dark">
              <div>ข้อมูลเกี่ยวกับความสัมพันธ์ทางสังคม</div>
            </div>
            <div class="col border border-dark">
              <div>
                ข้อมูลความสัมพันธ์ทางสังคมของท่าน เช่น สถานภาพทางการเมือง
                การดำรงตำแหน่งทางการเมือง การดำรงตำแหน่งกรรมการ
                ความสัมพันธ์กับผู้ปฏิบัติงานของ S2
                ข้อมูลการเป็นผู้มีสัญญาจ้างกับ S2
                ข้อมูลการเป็นผู้มีส่วนได้เสียในกิจการที่ทำกับ S2 เป็นต้น
              </div>
            </div>
          </div>

          <div class="row border border-dark">
            <div class="col-6 border border-dark">
              <div>ข้อมูลเกี่ยวกับการใช้บริการของ S2</div>
            </div>
            <div class="col-6 border border-dark">
              <div>
                รายละเอียดเกี่ยวกับผลิตภัณฑ์หรือบริการของ S2 เช่น
                ชื่อบัญชีผู้ใช้งาน รหัสผ่าน หมายเลข PIN ข้อมูล Single Sign-on
                (SSO ID) รหัส OTP ข้อมูลการจราจรทางคอมพิวเตอร์ ข้อมูลระบุพิกัด
                ภาพถ่าย วีดีโอ บันทึกเสียง ข้อมูลพฤติกรรมการใช้งาน
                (เว็บไซต์ที่อยู่ในความดูแลของ S2 เช่น https://stockradars.co
                หรือแอปพลิเคชันต่าง ๆ) ประวัติการสืบค้น
                คุกกี้หรือเทคโนโลยีในลักษณะเดียวกัน หมายเลขอุปกรณ์ (Device ID)
                ประเภทอุปกรณ์ รายละเอียดการเชื่อมต่อ ข้อมูล Browser
                ภาษาที่ใช้งาน ระบบปฏิบัติการที่ใช้งาน เป็นต้น
              </div>
            </div>
          </div>

          <div class="row border border-dark mb-3">
            <div class="col border border-dark">
              <div>ข้อมูลส่วนบุคคลที่มีความละเอียดอ่อน</div>
            </div>
            <div class="col border border-dark">
              <div>
                ข้อมูลส่วนบุคคลที่มีความละเอียดอ่อนของท่าน เช่น เชื้อชาติ
                ข้อมูลศาสนา ข้อมูลความพิการ ข้อมูลความเห็นทางการเมือง
                ประวัติอาชญากรรม ข้อมูลชีวภาพ (ข้อมูลภาพจำลองใบหน้า)
                ข้อมูลเกี่ยวกับสุขภาพ เป็นต้น
              </div>
            </div>
          </div>
        </div>

        <div class="mb-3">
          <b>7. คุกกี้</b>
        </div>
        <div class="mb-3">
          S2
          เก็บรวบรวมและใช้คุกกี้รวมถึงเทคโนโลยีอื่นในลักษณะเดียวกันในเว็บไซต์ที่อยู่ภายใต้ความดูแลของ
          S2 เช่น https://stockradars.co
          หรือบนอุปกรณ์ของท่านตามแต่บริการที่ท่านใช้งาน ทั้งนี้
          เพื่อการดำเนินการด้านความปลอดภัยในการให้บริการของ S2
          และเพื่อให้ท่านซึ่งเป็นผู้ใช้งานได้รับความสะดวกและประสบการณ์ที่ดีในการใช้งานบริการของ
          S2 และข้อมูลเหล่านี้จะถูกนำไปเพื่อปรับปรุงเว็บไซต์ของ S2
          ให้ตรงกับความต้องการของท่านมากยิ่งขึ้น
          โดยท่านสามารถตั้งค่าหรือลบการใช้งานคุกกี้ได้ด้วยตนเองจากการตั้งค่าในเว็บเบราว์เซอร์
          (Web Browser) ของท่าน
        </div>
        <div class="mb-3">
          <b
          >8. ข้อมูลส่วนบุคคลของผู้เยาว์
            คนไร้ความสามารถและคนเสมือนไร้ความสามารถ</b
          >
        </div>
        <div class="mb-3">
          กรณีที่ S2
          ทราบว่าข้อมูลส่วนบุคคลที่จำเป็นต้องได้รับความยินยอมในการเก็บรวบรวม
          เป็นของเจ้าของข้อมูลส่วนบุคคลซึ่งเป็นผู้เยาว์
          คนไร้ความสามารถหรือคนเสมือนไร้ความสามารถ S2
          จะไม่ทำการเก็บรวบรวมข้อมูลส่วนบุคคลนั้นจนกว่าจะได้รับความยินยอมจากผู้ใช้อำนาจปกครองที่มีอำนาจกระทำการแทนผู้เยาว์
          หรือผู้อนุบาล หรือผู้พิทักษ์ตามแต่กรณี ทั้งนี้
          เป็นไปตามเงื่อนไขที่กฎหมายกำหนด กรณีที่ S2
          ไม่ทราบมาก่อนว่าเจ้าของข้อมูลส่วนบุคคลเป็นผู้เยาว์
          คนไร้ความสามารถหรือคนเสมือนไร้ความสามารถ และมาพบในภายหลังว่า S2
          ได้เก็บรวบรวมข้อมูลของเจ้าของข้อมูลส่วนบุคคลดังกล่าวโดยยังมิได้รับความยินยอมจากผู้ใช้อำนาจปกครองที่มีอำนาจกระทำการแทนผู้เยาว์
          หรือผู้อนุบาล หรือผู้พิทักษ์ตามแต่กรณี ดังนี้ S2
          จะดำเนินการลบทำลายข้อมูลส่วนบุคคลนั้นโดยเร็วหาก S2
          ไม่มีเหตุอันชอบด้วยกฎหมายประการอื่นนอกเหนือจากความยินยอมในการเก็บรวบรวม
          ใช้หรือเปิดเผยข้อมูลดังกล่าว
        </div>
        <div class="mb-3">
          <b>9. วัตถุประสงค์ในการเก็บรวบรวมข้อมูลส่วนบุคคล</b>
        </div>
        <div class="mb-3">
          S2
          ดำเนินการเก็บรวบรวมข้อมูลส่วนบุคคลของท่านเพื่อวัตถุประสงค์หลายประการ
          ซึ่งขึ้นอยู่กับประเภทของผลิตภัณฑ์หรือบริการหรือกิจกรรมที่ท่านใช้บริการ
          ตลอดจนลักษณะความสัมพันธ์ของท่านกับ S2
          หรือข้อพิจารณาในแต่ละบริบทเป็นสำคัญ
          โดยวัตถุประสงค์ที่ระบุไว้ดังต่อไปนี้เป็นเพียงกรอบการใช้ข้อมูลส่วนบุคคลของ
          S2 เป็นการทั่วไป ทั้งนี้
          เฉพาะวัตถุประสงค์ที่เกี่ยวข้องกับผลิตภัณฑ์หรือบริการที่ท่านใช้งานหรือมีความสัมพันธ์ด้วยเท่านั้นที่จะมีผลบังคับใช้กับข้อมูลของท่าน
          <br/>1) เพื่อดำเนินการตามที่จำเป็นในการดำเนินประโยชน์สาธารณะที่ S2
          ได้รับมอบหมายให้สำเร็จลุล่วง
          หรือเป็นการจำเป็นเพื่อใช้อำนาจทางกฎหมายที่ S2
          มีอำนาจหน้าที่ในการดำเนินการตามพันธกิจดังปรากฏในพระราชกฤษฎีกาจัดตั้งสำนักงานพัฒนารัฐบาลดิจิทัล
          (องค์การมหาชน) พ.ศ. 2561 และกฎหมาย กฎ
          ระเบียบหรือคำสั่งที่เกี่ยวข้อง<br/>
          2)เพื่อให้บริการและบริหารจัดการบริการของ
          S2ทั้งบริการภายใต้สัญญาที่มีต่อท่าน หรือตามพันธกิจของ S2<br/>
          3) เพื่อการดำเนินการทางธุรกรรมของ S2<br/>
          4) ควบคุมดูแล ใช้งาน ติดตาม
          ตรวจสอบและบริหารจัดการบริการเพื่ออำนวยความสะดวกและสอดคล้องกับความต้องการของท่าน<br/>
          5) เพื่อเก็บรักษาและปรับปรุงข้อมูลอันเกี่ยวกับท่าน
          รวมทั้งเอกสารที่มีการกล่าวอ้างถึงท่าน<br/>
          6) จัดทำบันทึกรายการการประมวลผลข้อมูลส่วนบุคคลตามที่กฎหมายกำหนด<br/>
          7) วิเคราะห์ข้อมูล รวมถึงแก้ไขปัญหาที่เกี่ยวกับบริการของ S2<br/>
          8) เพื่อดำเนินการตามที่จำเป็นในการบริหารจัดการภายในองค์กร
          รวมถึงการรับสมัครงาน การสรรหากรรมการหรือผู้ดำรงตำแหน่งต่าง ๆ
          และการประเมินคุณสมบัติ<br/>
          9) ป้องกัน ตรวจจับ หลีกเลี่ยง และตรวจสอบการฉ้อโกง การละเมิดความปลอดภัย
          หรือการกระทำที่ต้องห้าม หรือผิดกฎหมาย และอาจเกิดความเสียหายต่อทั้ง S2
          และเจ้าของข้อมูลส่วนบุคคล<br/>
          10) การยืนยันตัวตน
          พิสูจน์ตัวตนและตรวจสอบข้อมูลเมื่อท่านสมัครใช้บริการของ S2
          หรือติดต่อใช้บริการ หรือใช้สิทธิตามกฎหมาย<br/>
          11) ปรับปรุงและพัฒนาคุณภาพผลิตภัณฑ์และบริการให้ทันสมัย<br/>
          12) การประเมินและบริหารจัดการความเสี่ยง<br/>
          13) ส่งการแจ้งเตือน การยืนยันการทำคำสั่ง ติดต่อสื่อสาร
          และแจ้งข่าวสารไปยังท่าน<br/>
          14) เพื่อจัดทำและส่งมอบเอกสารหรือข้อมูลที่มีความเกี่ยวข้องและจำเป็น<br/>
          15) ยืนยันตัวตน ป้องกันการสแปม หรือการกระทำที่ไม่ได้รับอนุญาต
          หรือผิดกฎหมาย<br/>
          16) ตรวจสอบว่าเจ้าของข้อมูลส่วนบุคคลเข้าถึงและใช้บริการของ S2 อย่างไร
          ทั้งในภาพรวมและรายบุคคล และเพื่อวัตถุประสงค์ที่เกี่ยวกับการค้นคว้า
          และการวิเคราะห์<br/>
          17) ดำเนินการตามที่จำเป็นเพื่อปฏิบัติตามหน้าที่ที่ S2
          มีต่อหน่วยงานที่มีอำนาจควบคุม หน่วยงานด้านภาษี การบังคับใช้กฎหมาย
          หรือภาระผูกพันตามกฎหมายของ S2<br/>
          18) ดำเนินการตามที่จำเป็นเพื่อประโยชน์ที่ชอบด้วยกฎหมายของ S2
          หรือของบุคคลอื่น
          หรือของนิติบุคคลอื่นที่เกี่ยวข้องกับการการดำเนินการของสำนักงานพัฒนารัฐบาลดิจิทัล
          (องค์การมหาชน) หรือ สพร.<br/>
          19) ป้องกัน หรือหยุดยั้งอันตรายต่อชีวิต ร่างกาย
          หรือสุขภาพของบุคคลซึ่งรวมถึงการเฝ้าระวังโรคระบาด<br/>
          20) จัดเตรียมเอกสารทางประวัติศาสตร์เพื่อประโยชน์สาธารณะ การค้นคว้า
          หรือจัดทำสถิติที่ S2 ได้รับมอบหมายให้ดำเนินการ<br/>
          21) เพื่อการปฏิบัติตามกฎหมาย ประกาศ คำสั่งที่มีผลบังคับใช้
          หรือการดำเนินการเกี่ยวกับคดีความ การดำเนินการเกี่ยวกับข้อมูลตามหมายศาล
          รวมถึงการใช้สิทธิเกี่ยวกับข้อมูลของท่าน<br/>
        </div>
        <div class="mb-3">
          <b>10. ประเภทบุคคลที่ S2 เปิดเผยข้อมูลส่วนบุคคลของท่าน</b>
        </div>
        <div class="mb-3">
          ภายใต้วัตถุประสงค์ที่ได้ระบุไว้ในข้อ 9 ข้างต้น S2
          อาจเปิดเผยข้อมูลส่วนบุคคลของท่านให้แก่บุคคลดังต่อไปนี้ ทั้งนี้
          ประเภทของบุคคลผู้รับข้อมูลที่ระบุไว้ดังต่อไปนี้เป็นเพียงกรอบการเปิดเผยข้อมูลส่วนบุคคลของ
          S2 เป็นการทั่วไป
          เฉพาะบุคคลผู้รับข้อมูลที่เกี่ยวข้องกับผลิตภัณฑ์หรือบริการที่ท่านใช้งานหรือมีความสัมพันธ์ด้วยเท่านั้นที่จะมีผลบังคับใช้
        </div>

        <div class="container">
          <div class="row border border-dark">
            <div class="col border border-dark">
              <div class="text-center">
                <b>ประเภทบุคคลผู้รับข้อมูล</b>
              </div>
            </div>
            <div class="col border border-dark">
              <div class="text-center"><b>รายละเอียด</b></div>
            </div>
          </div>

          <div class="row border border-dark">
            <div class="col border border-dark">
              <div>
                หน่วยงานของรัฐหรือผู้มีอำนาจที่ S2
                ต้องเปิดเผยข้อมูลเพื่อวัตถุประสงค์ในการดำเนินการตามกฎหมายหรือวัตถุประสงค์สำคัญอื่น
                (เช่น การดำเนินการเพื่อประโยชน์สาธารณะ)
              </div>
            </div>
            <div class="col border border-dark">
              <div>
                หน่วยงานผู้บังคับใช้กฎหมาย หรือมีอำนาจควบคุมกำกับดูแล
                หรือมีวัตถุประสงค์อื่นที่มีความสำคัญ เช่น คณะรัฐมนตรี
                รัฐมนตรีผู้รักษาการ กรมการปกครอง กรมสรรพากร สำนักงานตำรวจ ศาล
                สำนักงานอัยการ กรมควบคุมโรค กระทรวงดิจิทัลเพื่อเศรษฐกิจและสังคม
                สำนักงานปลัดสำนักนายก กรมการกงสุล
                กองทุนเงินให้กู้ยืมเพื่อการศึกษา เป็นต้น
              </div>
            </div>
          </div>

          <div class="row border border-dark">
            <div class="col border border-dark">
              <div>
                คณะกรรมการต่าง ๆ ที่เกี่ยวข้องกับการดำเนินการตามกฎหมายของ S2
              </div>
            </div>
            <div class="col border border-dark">
              <div>
                S2 อาจเปิดเผยข้อมูลของท่านแก่บุคคลผู้ดำรงตำแหน่งกรรมการในคณะต่าง
                ๆ เช่น คณะอนุกรรมการสรรหา คณะกรรมการสำนักงานพัฒนารัฐบาลดิจิทัล
                เป็นต้น
              </div>
            </div>
          </div>

          <div class="row border border-dark">
            <div class="col border border-dark">
              <div>
                คู่สัญญาซึ่งดำเนินการเกี่ยวกับสวัสดิการของผู้ปฏิบัติงานของ S2
              </div>
            </div>
            <div class="col border border-dark">
              <div>
                บุคคลภายนอกที่ S2 จัดซื้อจัดจ้างให้ดำเนินการเกี่ยวกับสวัสดิการ
                เช่น บริษัทประกันภัย โรงพยาบาล บริษัทผู้จัดทำ Payroll ธนาคาร
                ผู้ให้บริการโทรศัพท์ เป็นต้น
              </div>
            </div>
          </div>

          <div class="row border border-dark">
            <div class="col border border-dark">
              <div>พันธมิตรทางธุรกิจ</div>
            </div>
            <div class="col border border-dark">
              <div>S2 อาจเปิดเผยข้อมูลของท่านแก่บุคคลที่ร่วมงานกับ</div>
            </div>
          </div>

          <div class="row border border-dark">
            <div class="col border border-dark">
              <div></div>
            </div>
            <div class="col border border-dark">
              <div>
                S2 เพื่อประโยชน์ในการให้บริการแก่ท่าน เช่น
                หน่วยงานผู้ให้บริการที่ท่านติดต่อผ่านบริการของ S2
                ผู้ให้บริการด้านการตลาด สื่อโฆษณา สถาบันการเงิน
                ผู้ให้บริการแพลตฟอร์ม ผู้ให้บริการโทรคมนาคม เป็นต้น
              </div>
            </div>
          </div>

          <div class="row border border-dark">
            <div class="col border border-dark">
              <div>ผู้ให้บริการ</div>
            </div>
            <div class="col border border-dark">
              <div>
                S2 อาจมอบหมายให้บุคคลอื่นเป็นผู้ให้บริการแทน
                หรือสนับสนุนการดำเนินการของ S2 เช่น
                ผู้ให้บริการด้านการจัดเก็บข้อมูล (เช่น คลาวด์ โกดังเอกสาร)
                ผู้พัฒนาระบบ ซอฟต์แวร์ แอปพลิเคชัน เว็บไซต์
                ผู้ให้บริการจัดส่งเอกสาร ผู้ให้บริการด้านการชำระเงิน
                ผู้ให้บริการอินเทอร์เน็ต ผู้ให้บริการโทรศัพท์ ผู้ให้บริการด้าน
                Digital ID ผู้ให้บริการสื่อสังคมออนไลน์
                ผู้ให้บริการด้านการบริหารความเสี่ยง ที่ปรึกษาภายนอก
                ผู้ให้บริการขนส่ง เป็นต้น
              </div>
            </div>
          </div>

          <div class="row border border-dark">
            <div class="col border border-dark">
              <div>ผู้รับข้อมูลประเภทอื่น</div>
            </div>
            <div class="col border border-dark">
              <div>
                S2 อาจเปิดเผยข้อมูลของท่านให้แก่บุคคลผู้รับข้อมูลประเภทอื่น เช่น
                ผู้ติดต่อ S2 สมาชิกในครอบครัว มูลนิธิที่ไม่แสวงหากำไร วัด
                โรงพยาบาล สถานศึกษา หรือหน่วยงานอื่น ๆ เป็นต้น ทั้งนี้
                เพื่อการดำเนินการเกี่ยวกับบริการของ S2 การฝึกอบรม การรับรางวัล
                การร่วมทำบุญ บริจาค เป็นต้น
              </div>
            </div>
          </div>

          <div class="row border border-dark mb-3">
            <div class="col border border-dark">
              <div>การเปิดเผยข้อมูลต่อสาธารณะ</div>
            </div>
            <div class="col border border-dark">
              <div>
                S2 อาจเปิดเผยข้อมูลของท่านต่อสาธารณะในกรณีที่จำเป็น เช่น
                การดำเนินการที่กำหนดให้ S2
                ต้องประกาศลงในราชกิจจานุเบกษาหรือมติคณะรัฐมนตรี เป็นต้น
              </div>
            </div>
          </div>
        </div>

        <div class="mb-3">
          <b>11. การส่งหรือโอนข้อมูลส่วนบุคคลไปยังต่างประเทศ</b>
        </div>
        <div>
          ในบางกรณี S2
          อาจจำเป็นต้องส่งหรือโอนข้อมูลส่วนบุคคลของท่านไปยังต่างประเทศเพื่อดำเนินการตามวัตถุประสงค์ในการให้บริการแก่ท่าน
          เช่น เพื่อส่งข้อมูลส่วนบุคคลไปยังระบบคลาวด์ (Cloud)
          ที่มีแพลตฟอร์มหรือเครื่องแม่ข่าย (Server) อยู่ต่างประเทศ (เช่น
          ประเทศสิงคโปร์ หรือสหรัฐอเมริกา เป็นต้น)
          เพื่อสนับสนุนระบบเทคโนโลยีสารสนเทศที่ตั้งอยู่นอกประเทศไทย ทั้งนี้
          ขึ้นอยู่กับบริการของ S2
          ที่ท่านใช้งานหรือมีส่วนเกี่ยวข้องเป็นรายกิจกรรม
        </div>
        <div class="mb-3">
          อย่างไรก็ตาม ในขณะที่จัดทำนโยบายฉบับนี้
          คณะกรรมการคุ้มครองข้อมูลส่วนบุคคลยังมิได้มีประกาศกำหนดรายการประเทศปลายทางที่มีมาตรฐานการคุ้มครองข้อมูลส่วนบุคคลที่เพียงพอ
          ดังนี้ เมื่อ S2
          มีความจำเป็นต้องส่งหรือโอนข้อมูลส่วนบุคคลของท่านไปยังประเทศปลายทาง S2
          จะดำเนินการเพื่อให้ข้อมูลส่วนบุคคลที่ส่งหรือโอนไปมีมาตรการคุ้มครองข้อมูลส่วนบุคคลอย่างเพียงพอตามมาตรฐานสากล
          หรือดำเนินการตามเงื่อนไขเพื่อให้สามารถส่งหรือโอนข้อมูลนั้นได้ตามกฎหมาย
          ได้แก่
        </div>
        <div class="mb-3">
          1)เป็นการปฏิบัติตามกฎหมายที่กำหนดให้ S2
          ต้องส่งหรือโอนข้อมูลส่วนบุคคลไปต่างประเทศ<br/>
          2)ได้แจ้งให้ท่านทราบและได้รับความยินยอมจากท่านในกรณีที่ประเทศปลายทางมีมาตรฐานการคุ้มครองข้อมูลส่วนบุคคลที่ไม่เพียงพอ
          ทั้งนี้ตามประกาศรายชื่อประเทศที่คณะกรรมการคุ้มครองส่วนบุคคลประกาศกำหนด<br/>
          3)เป็นการจำเป็นเพื่อปฏิบัติตามสัญญาที่ท่านเป็นคู่สัญญากับ S2
          หรือเป็นการทำตามคำขอของท่านก่อนการเข้าทำสัญญานั้น<br/>
          4)เป็นการกระทำตามสัญญาของ S2 กับบุคคลหรือนิติบุคคลอื่น
          เพื่อประโยชน์ของท่าน<br/>
          5)เพื่อป้องกันหรือระงับอันตรายต่อชีวิต ร่างกาย
          หรือสุขภาพของท่านหรือของบุคคลอื่น
          เมื่อท่านไม่สามารถให้ความยินยอมในขณะนั้นได้<br/>
          6)เป็นการจำเป็นเพื่อดำเนินภารกิจเพื่อประโยชน์สาธารณะที่สำคัญ<br/>
        </div>

        <div class="mb-3">
          <b>12. ระยะเวลาในการเก็บรวบรวมข้อมูลส่วนบุคคลของท่าน</b>
        </div>
        <div class="mb-3">
          S2 จะเก็บรักษาข้อมูลส่วนบุคคลของท่าน
          ไว้ในระยะเวลาเท่าที่ข้อมูลนั้นยังมีความจำเป็นตามวัตถุประสงค์ในการเก็บรวบรวมข้อมูลเท่านั้น
          ตามรายละเอียดที่ได้กำหนดไว้ในนโยบาย ประกาศ หรือตามกฎหมายที่เกี่ยวข้อง
          ทั้งนี้
          เมื่อพ้นระยะเวลาและข้อมูลส่วนบุคคลของท่านสิ้นความจำเป็นตามวัตถุประสงค์ดังกล่าวแล้ว
          S2 จะทำการลบ ทำลายข้อมูลส่วนบุคคลของท่าน
          หรือทำให้ข้อมูลส่วนบุคคลของท่านไม่สามารถระบุตัวตนได้ต่อไป
          ตามรูปแบบและมาตรฐานการลบทำลายข้อมูลส่วนบุคคลที่คณะกรรมการหรือกฎหมายจะได้ประกาศกำหนดหรือตามมาตรฐานสากล
          อย่างไรก็ดี ในกรณีที่มีข้อพิพาท
          การใช้สิทธิหรือคดีความอันเกี่ยวข้องกับข้อมูลส่วนบุคคลของท่าน S2
          ขอสงวนสิทธิในการเก็บรักษาข้อมูลนั้นต่อไปจนกว่าข้อพิพาทนั้นจะได้มีคำสั่งหรือคำพิพากษาถึงที่สุด
        </div>
        <div class="mb-3">
          <b>13. การให้บริการโดยบุคคลที่สามหรือผู้ให้บริการช่วง </b>
        </div>
        <div class="mb-3">
          S2 อาจมีการมอบหมายหรือจัดซื้อจัดจ้างบุคคลที่สาม
          (ผู้ประมวลผลข้อมูลส่วนบุคคล)
          ให้ทำการประมวลผลข้อมูลส่วนบุคคลแทนหรือในนามของ S2
          ซึ่งบุคคลที่สามดังกล่าวอาจเสนอบริการในลักษณะต่าง ๆ เช่น การเป็นผู้ดูแล
          (Hosting) หรือเป็นผู้ให้บริการคลาวด์ (Cloud computing
          service/provider) หรือเป็นงานในลักษณะการจ้างทำของในรูปแบบอื่น<br/>การมอบหมายให้บุคคลที่สามทำการประมวลผลข้อมูลส่วนบุคคลในฐานะผู้ประมวลผลข้อมูลส่วนบุคคลนั้น
          S2 จะจัดให้มีข้อตกลงระบุสิทธิและหน้าที่ของ S2
          ในฐานะผู้ควบคุมข้อมูลส่วนบุคคลและของบุคคลที่ S2
          มอบหมายในฐานะผู้ประมวลผลข้อมูลส่วนบุคคล
          ซึ่งรวมถึงกำหนดรายละเอียดประเภทข้อมูลส่วนบุคคลที่ S2
          มอบหมายให้ประมวลผล รวมถึงวัตถุประสงค์
          ขอบเขตในการประมวลผลข้อมูลส่วนบุคคลและข้อตกลงอื่น ๆ ที่เกี่ยวข้อง
          ซึ่งผู้ประมวลผลข้อมูลส่วนบุคคลมีหน้าที่ประมวลผลข้อมูลส่วนบุคคลตามขอบเขตที่ระบุในข้อตกลงและตามคำสั่งของ
          S2 เท่านั้นโดยไม่สามารถประมวลผลเพื่อวัตถุประสงค์อื่นได้<br/>ในกรณีที่ผู้ประมวลผลข้อมูลส่วนบุคคลมีการมอบหมายผู้ให้บริการช่วง
          (ผู้ประมวลผลช่วง)
          เพื่อทำการประมวลผลข้อมูลส่วนบุคคลแทนหรือในนามของผู้ประมวลผลข้อมูลส่วนบุคคล
          ดังนี้ S2
          จะกำกับให้ผู้ประมวลผลข้อมูลส่วนบุคคลจัดให้มีเอกสารข้อตกลงระหว่างผู้ประมวลผลข้อมูลส่วนบุคคลกับผู้ประมวลผลช่วง
          ในรูปแบบและมาตรฐานที่ไม่ต่ำกว่าข้อตกลงระหว่าง S2
          กับผู้ประมวลผลข้อมูลส่วนบุคคล
        </div>
        <div class="mb-3">
          <b>14. การรักษาความมั่นคงปลอดภัยของข้อมูลส่วนบุคคล </b>
        </div>
        <div class="mb-3">
          S2 มีมาตรการปกป้องข้อมูลส่วนบุคคล
          โดยการจำกัดสิทธิ์การเข้าถึงข้อมูลส่วนบุคคลให้สามารถเข้าถึงได้โดยเจ้าหน้าที่เฉพาะรายหรือบุคคลที่มีอำนาจหน้าที่หรือได้รับมอบหมายที่มีความจำเป็นต้องใช้ข้อมูลดังกล่าว
          ตามวัตถุประสงค์ที่ได้แจ้งเจ้าของข้อมูลส่วนบุคคลไว้แล้วเท่านั้น
          ซึ่งบุคคลดังกล่าวจะต้องยึดมั่นและปฏิบัติตามมาตรการปกป้องข้อมูลส่วนบุคคลของ
          S2 อย่างเคร่งครัด
          ตลอดจนมีหน้าที่รักษาความลับของข้อมูลส่วนบุคคลที่ตนเองรับรู้จากการปฏิบัติการตามอำนาจหน้าที่
          โดย S2
          มีมาตรการรักษาความปลอดภัยข้อมูลทั้งในเชิงองค์กรหรือเชิงเทคนิคที่ได้มาตรฐานสากล
          และเป็นไปตามที่คณะกรรมการคุ้มครองข้อมูลส่วนบุคคลประกาศกำหนด
        </div>
        <div class="mb-3">
          นอกจากนี้ เมื่อ S2 มีการส่ง โอน
          หรือเปิดเผยข้อมูลส่วนบุคคลแก่บุคคลที่สาม
          ไม่ว่าเพื่อการให้บริการตามพันธกิจ ตามสัญญา หรือข้อตกลงในรูปแบบอื่น S2
          จะกำหนดมาตรการรักษาความปลอดภัยข้อมูลส่วนบุคคลและการรักษาความลับที่เหมาะสมและเป็นไปตามที่กฎหมายกำหนด
          เพื่อยืนยันว่าข้อมูลส่วนบุคคลที่ S2
          เก็บรวบรวมจะมีความมั่นคงปลอดภัยอยู่เสมอ
        </div>

        <div class="mb-3">
          <b>15. การเชื่อมต่อเว็บไซต์หรือบริการภายนอก</b>
        </div>
        <div class="mb-3">
          บริการของ S2 อาจมีการเชื่อมต่อไปยังเว็บไซต์หรือบริการของบุคคลที่สาม
          ซึ่งเว็บไซต์หรือบริการดังกล่าวอาจมีการประกาศนโยบายการคุ้มครองข้อมูลส่วนบุคคลที่มีเนื้อหาสาระแตกต่างจากนโยบายนี้
          S2
          ขอแนะนำให้ท่านศึกษานโยบายการคุ้มครองข้อมูลส่วนบุคคลของเว็บไซต์หรือบริการนั้น
          ๆ เพื่อทราบใน
        </div>
        <div class="mb-3">
          รายละเอียดก่อนการเข้าใช้งาน ทั้งนี้ S2
          ไม่มีความเกี่ยวข้องและไม่มีอำนาจควบคุมถึงมาตรการคุ้มครองข้อมูลส่วนบุคคลของเว็บไซต์หรือบริการดังกล่าว
          และไม่สามารถรับผิดชอบต่อเนื้อหา นโยบาย ความเสียหาย
          หรือการกระทำอันเกิดจากเว็บไซต์หรือบริการของบุคคลที่สาม
        </div>

        <div class="mb-3">
          <b>16. เจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล</b>
        </div>
        <div class="mb-3">
          S2 ได้แต่งตั้งเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคลเพื่อทำหน้าที่ตรวจสอบ
          กำกับ และให้คำแนะนำในการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคล
          รวมถึงการประสานงานและให้ความร่วมมือกับสำนักงานคณะกรรมการคุ้มครองข้อมูลส่วนบุคคล
          เพื่อให้สอดคล้องตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562
        </div>

        <div class="mb-3">
          <b
          >17. สิทธิของท่านตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ.
            2562</b
          >
        </div>
        <div class="mb-3">
          พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562
          ได้กำหนดสิทธิของเจ้าของข้อมูลส่วนบุคคลไว้หลายประการ ทั้งนี้
          สิทธิดังกล่าวจะเริ่มมีผลบังคับใช้เมื่อกฎหมายในส่วนของสิทธินี้มีผลใช้บังคับ
          โดยรายละเอียดของสิทธิต่าง ๆ ประกอบด้วย
        </div>

        <div class="mb-3">
          <b>1) สิทธิในการขอเข้าถึงข้อมูลส่วนบุคคล</b>ท่านมีสิทธิ ขอเข้าถึง
          รับสำเนา และขอให้เปิดเผยที่มาของข้อมูลส่วนบุคคลที่ S2
          เก็บรวบรวมไว้โดยปราศจากความยินยอมของท่าน เว้นแต่กรณีที่ S2
          มีสิทธิปฏิเสธคำขอของท่านด้วยเหตุตามกฎหมายหรือคำสั่งศาล
          หรือกรณีที่การใช้สิทธิของท่านจะมีผลกระทบที่อาจก่อให้เกิดความเสียหายต่อสิทธิและเสรีภาพของบุคคลอื่น
        </div>
        <div class="mb-3">
          <b>2) สิทธิในการขอแก้ไขข้อมูลส่วนบุคคลให้ถูกต้อง</b
          >สมบูรณ์และเป็นปัจจุบัน หากท่านพบว่าข้อมูลส่วนบุคคลของท่านไม่ถูกต้อง
          ไม่ครบถ้วนหรือไม่เป็นปัจจุบัน
          ท่านมีสิทธิขอให้แก้ไขเพื่อให้มีความถูกต้อง เป็นปัจจุบัน สมบูรณ์
          และไม่ก่อให้เกิดความเข้าใจผิดได้
        </div>

        <div class="mb-3">
          <b>3) สิทธิในการลบหรือทำลายข้อมูลส่วนบุคคล </b>ท่านมีสิทธิขอให้ S2
          ลบหรือทำลายข้อมูลส่วนบุคคลของท่าน
          หรือทำให้ข้อมูลส่วนบุคคลของท่านไม่สามารถระบุตัวบุคคลที่เป็นเจ้าของข้อมูลได้ต่อไป
          ทั้งนี้
          การใช้สิทธิลบหรือทำลายข้อมูลส่วนบุคคลนี้จะต้องอยู่ภายใต้เงื่อนไขตามที่กฎหมายกำหนด
        </div>

        <div class="mb-3">
          <b>4) สิทธิในการขอให้ระงับการใช้ข้อมูลส่วนบุคคล</b
          >ท่านมีสิทธิขอให้ระงับการใช้ข้อมูลส่วนบุคคลของท่าน ทั้งนี้
          ในกรณีดังต่อไปนี้<br/>
          ก) เมื่ออยู่ในช่วงเวลาที่ S2
          ทำการตรวจสอบตามคำร้องขอของเจ้าของข้อมูลส่วนบุคคลให้แก้ไขข้อมูลส่วนบุคคลให้ถูกต้อง
          สมบูรณ์และเป็นปัจจุบัน<br/>
          ข) ข้อมูลส่วนบุคคลของเจ้าของข้อมูลส่วนบุคคลถูกเก็บรวบรวม
          ใช้หรือเปิดเผยโดยมิชอบด้วยกฎหมาย<br/>
          ค)
          เมื่อข้อมูลส่วนบุคคลของเจ้าของข้อมูลส่วนบุคคลหมดความจำเป็นในการเก็บรักษาไว้ตามวัตถุประสงค์ที่
          S2 ได้แจ้งในการเก็บรวบรวม แต่เจ้าของข้อมูลส่วนบุคคลประสงค์ให้ S2
          เก็บรักษาข้อมูลนั้นต่อไปเพื่อประกอบการใช้สิทธิตามกฎหมาย<br/>
          ง) เมื่ออยู่ในช่วงเวลาที่ S2
          กำลังพิสูจน์ถึงเหตุอันชอบด้วยกฎหมายในการเก็บรวบรวมข้อมูลส่วนบุคคลของเจ้าของข้อมูลส่วนบุคคล
          หรือตรวจสอบความจำเป็นในการเก็บรวบรวม ใช้
          หรือเปิดเผยข้อมูลส่วนบุคคลเพื่อประโยชน์สาธารณะ
          อันเนื่องมาจากการที่เจ้าของข้อมูลส่วนบุคคลได้ใช้สิทธิคัดค้านการเก็บรวบรวม
          ใช้ หรือเปิดเผยข้อมูลส่วนบุคคล
        </div>

        <div class="mb-3">
          <b>5) สิทธิในการคัดค้านการประมวลผลข้อมูลส่วนบุคคล</b
          >ท่านมีสิทธิคัดค้านการเก็บรวบรวม ใช้
          หรือเปิดเผยข้อมูลส่วนบุคคลที่เกี่ยวกับท่าน เว้นแต่กรณีที่ S2
          มีเหตุในการปฏิเสธคำขอโดยชอบด้วยกฎหมาย (เช่น S2
          สามารถแสดงให้เห็นว่าการเก็บรวบรวม ใช้
          หรือเปิดเผยข้อมูลส่วนบุคคลของท่านมีเหตุอันชอบด้วยกฎหมายยิ่งกว่า
          หรือเพื่อการก่อตั้งสิทธิเรียกร้องตามกฎหมาย
          การปฏิบัติตามหรือการใช้สิทธิเรียกร้องทางกฎหมาย
          หรือเพื่อประโยชน์สาธารณะของ S2)
        </div>
        <div class="mb-3">
          <b>6) สิทธิในการขอถอนความยินยอม</b> ในกรณีที่ท่านได้ให้ความยินยอมแก่
          S2 ในการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคล
          (ไม่ว่าความยินยอมนั้นจะได้ให้ไว้ก่อนหรือหลังพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล
          พ.ศ. 2562 มีผลใช้บังคับ)
          ท่านมีสิทธิถอนความยินยอมเมื่อใดก็ได้ตลอดระยะเวลาที่ข้อมูลส่วนบุคคลของท่านถูกเก็บรักษาโดย
          S2 เว้นแต่มีข้อจำกัดสิทธิโดยกฎหมายให้ S2
          จำเป็นต้องเก็บรักษาข้อมูลต่อไป หรือ ยังคงมีสัญญาระหว่างท่านกับ S2
          ที่ให้ประโยชน์แก่ท่านอยู่
        </div>

        <div class="mb-3">
          <b>7) สิทธิในการขอรับ ส่งหรือโอนข้อมูลส่วนบุคคล</b>
          ท่านมีสิทธิในการขอรับข้อมูลส่วนบุคคลของท่านจาก S2
          ในรูปแบบที่สามารถอ่านหรือใช้งานโดยทั่วไปได้
          ด้วยเครื่องมือหรืออุปกรณ์ที่ทำงานได้โดยอัตโนมัติ
          และสามารถใช้หรือเปิดเผยข้อมูลส่วนบุคคลได้โดยวิธีการอัตโนมัติ
          รวมถึงอาจขอให้ S2
          ส่งหรือโอนข้อมูลในรูปแบบดังกล่าวไปยังผู้ควบคุมข้อมูลส่วนบุคคลรายอื่น
          ทั้งนี้ การใช้สิทธินี้จะต้องอยู่ภายใต้เงื่อนไขตามที่กฎหมายกำหนด
        </div>

        <div class="mb-3">
          <b>18. โทษของการไม่ปฏิบัติตามนโยบายการคุ้มครองข้อมูลส่วนบุคคล </b>
        </div>
        <div class="mb-3">
          การไม่ปฏิบัติตามนโยบายอาจมีผลเป็นความผิดและถูกลงโทษทางวินัยตามกฎเกณฑ์ของ
          S2 (สำหรับเจ้าหน้าที่หรือผู้ปฏิบัติงานของ S2)
          หรือตามข้อตกลงการประมวลผลข้อมูลส่วนบุคคล
          (สำหรับผู้ประมวลผลข้อมูลส่วนบุคคล) ทั้งนี้
          ตามแต่กรณีและความสัมพันธ์ที่ท่านมีต่อ S2
          และอาจได้รับโทษตามที่กำหนดโดยพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ.
          2562 รวมทั้งกฎหมายลำดับรอง กฎ ระเบียบ และคำสั่งที่เกี่ยวข้อง
        </div>

        <div class="mb-3">
          <b>19. การร้องเรียนต่อหน่วยงานผู้มีอำนาจกำกับดูแล</b>
        </div>
        <div class="mb-3">
          ในกรณีที่ท่านพบว่า S2 มิได้ปฏิบัติตามกฎหมายคุ้มครองข้อมูลส่วนบุคคล
          ท่านมีสิทธิร้องเรียนไปยังคณะกรรมการคุ้มครองข้อมูลส่วนบุคคล
          หรือหน่วยงานที่มีอำนาจกำกับดูแลที่ได้รับการแต่งตั้งโดยคณะกรรมการคุ้มครองข้อมูลส่วนบุคคลหรือตามกฎหมาย
          ทั้งนี้ ก่อนการร้องเรียนดังกล่าว S2 ขอให้ท่านโปรดติดต่อมายัง S2
          เพื่อให้ S2 มีโอกาสได้รับทราบข้อเท็จจริงและได้ชี้แจงในประเด็นต่าง ๆ
          รวมถึงจัดการแก้ไขข้อกังวลของท่านก่อนในโอกาสแรก
        </div>

        <div class="mb-3">
          <b>20. การปรับปรุงแก้ไขนโยบายการคุ้มครองข้อมูลส่วนบุคคล</b>
        </div>
        <div class="mb-3">
          S2 อาจพิจารณาปรับปรุง แก้ไข หรือเปลี่ยนแปลงนโยบายนี้ตามที่เห็นสมควร
          และจะทำการแจ้งให้ท่านทราบผ่านช่องทางเว็บไซต์ https://stockradars.co
          โดยมีวันที่มีผลบังคับใช้ของแต่ละฉบับแก้ไขกำกับอยู่ อย่างไรก็ดี S2
          ขอแนะนำให้ท่านโปรดตรวจสอบเพื่อรับทราบนโยบายฉบับใหม่อย่างสม่ำเสมอ
          ผ่านแอปพลิเคชัน หรือช่องทางเฉพาะกิจกรรมที่ S2 ดำเนินการ
          โดยเฉพาะก่อนที่ท่านจะทำการเปิดเผยข้อมูลส่วนบุคคลแก่ S2
          การเข้าใช้งานผลิตภัณฑ์หรือบริการของ S2 ภายหลังการบังคับใช้นโยบายใหม่
          ถือเป็นการรับทราบตามข้อตกลงในนโยบายใหม่แล้ว ทั้งนี้
          โปรดหยุดการเข้าใช้งานหากท่านไม่เห็นด้วยกับรายละเอียดในนโยบายฉบับนี้
          และโปรดติดต่อมายัง S2 เพื่อชี้แจงข้อเท็จจริงต่อไป
        </div>

        <div class="mb-3">
          <b>21. การติดต่อสอบถามหรือใช้สิทธิ</b>
        </div>
        <div>
          หากท่านมีข้อสงสัย ข้อเสนอแนะ หรือข้อกังวลเกี่ยวกับการเก็บรวบรวม ใช้
          และเปิดเผยข้อมูลส่วนบุคคลของ S2 หรือเกี่ยวกับนโยบายนี้
          หรือท่านต้องการใช้สิทธิตามกฎหมายคุ้มครองข้อมูลส่วนบุคคล
          ท่านสามารถติดต่อสอบถามได้ที่
        </div>

        <div>
          <b>1) ผู้ควบคุมข้อมูลส่วนบุคคล (Data Controller)</b>
        </div>
        <div>
          - ชื่อ: บริษัท สยามสแควร์ เทคโนโลยี (ประเทศไทย) จำกัด<br/>
          - สถานที่ติดต่อ: 23/69-71 ซอยศูนย์วิจัย ถนนพระรามเก้า แขวงบางกะปิ
          เขตห้วยขวาง กรุงเทพมหานคร 10310<br/>
          - ช่องทางการติดต่อ: dpo@siamsquared.com Call Center : 09 2249 4999<br/>
        </div>

        <div>
          <b
          >2) เจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล (Data Protection Officer:
            DPO)
          </b>
        </div>
        <div class="mb-5">
          - สถานที่ติดต่อ: บริษัท สยามสแควร์ เทคโนโลยี (ประเทศไทย) จำกัด<br/>
          - สถานที่ติดต่อ: 23/69-71 ซอยศูนย์วิจัย ถนนพระรามเก้า แขวงบางกะปิ
          เขตห้วยขวาง กรุงเทพมหานคร 10310<br/>
          - ช่องทางการติดต่อ: dpo@siamsquared.com Call Center : 09 2249 4999<br/>
        </div>
        <div class="mb-3 text-center">Update Date: 1 June 2022</div>
      </div>
    </div>

    <div class="row align-items-center" v-if="lang === 'en'">
      <div class="col">
        <div class="mb-5"><h2>StockRadars PDPA Privacy Policy</h2></div>
        <div class="mb-3 fw-bold"><b>1. Introduction</b></div>
        <div class="mb-3"> SiamSquared Technologies (Thailand) Co., Ltd. and its affiliates (hereinafter referred to as
          "S2" or "the organization" or "the company") recognize the importance of personal data and other information
          relating to you (collectively referred to as "data"). To ensure that you can trust S2's transparency and
          responsibility in collecting, using, or disclosing your data in accordance with the Personal Data Protection
          Act B.E. 2562 (2019) ("Personal Data Protection Act") and other relevant laws, this Personal Data Protection
          Policy ("Policy") has been established to inform you of the details regarding the collection, use, or
          disclosure (collectively referred to as "processing") of personal data conducted by S2, including officers and
          related persons acting on behalf of or in the name of S2. The content is as follows:
        </div>
        <div class="mb-3"><b>2. Scope of Policy Application</b></div>
        <div class="mb-3"> This policy applies to the personal data of individuals who have a current or potential
          future relationship with S2, which is processed by S2, its officers, contract employees, business units, or
          other operational units of S2, as well as contractors or third parties who process personal data on behalf of
          or in the name of S2 ("personal data processors"). This includes various products and services such as
          websites, systems, applications, documents, or other forms of services controlled by S2 (collectively referred
          to as "services").
        </div>
        <div class="mb-3"> Individuals who have a relationship with S2 as mentioned in the first paragraph include:
          <br>
          1) individual customers<br>
          2) officers or operators, employees<br>
          3) partners and service providers who are natural persons<br>
          4) directors, authorized persons, representatives, agents, shareholders, employees, or other persons with
          similar relationships of juristic persons associated with S2<br>
          5) users of S2's products or services<br>
          6) visitors or users of the website https://stockradars.co, as well as systems, applications, devices, or
          other communication channels controlled by S2<br>
          7) other individuals whose personal data is collected by S2, such as job applicants, family members of
          officers, guarantors, beneficiaries in insurance policies, etc. Items 1) to 6) are collectively referred to as
          "you".
        </div>
        <div class="mb-3"> In addition to this policy, S2 may establish privacy notices ("Notices") for S2's products or
          services to inform the personal data owners who are service users about the personal data being processed, the
          purposes and legal bases for processing, the retention period of personal data, as well as the rights to
          personal data that the personal data owner should have in that specific product or service. In case of any
          material conflict between the content of the privacy notice and this policy, the content of the privacy notice
          for that particular service shall prevail.
        </div>
        <div class="mb-3"><b>3. Definitions</b></div>
        <div class="mb-3">
          - <b>S2 </b>refers to SiamSquared Technologies (Thailand) Co., Ltd. and its affiliates.<br>
          - <b>Personal Data </b> means information relating to a natural person, which enables the identification of
          such person, whether directly or indirectly, but not including the information of the deceased persons in
          particular.<br>

          - <b>Sensitive Personal Data</b> means personal data as stipulated in Section 26 of the Personal Data
          Protection Act B.E. 2562 (2019), which includes racial, ethnic origin, political opinions, cult, religious or
          philosophical beliefs, sexual behavior, criminal records, health data, disability, trade union information,
          genetic data, biometric data, or any other data which may affect the data subject in a similar manner, as
          prescribed by the Personal Data Protection Committee.
          <br>

          - <b>Personal Data Processing </b> means any operation performed on personal data, such as collection,
          recording, copying, organization, storage, adaptation or alteration, retrieval, disclosure, forwarding,
          dissemination, transfer, combination, erasure, or destruction.
          <br>

          - <b>Data Subject</b> means a natural person who is the owner of the personal data collected, used, or
          disclosed by S2.

          - <b>Data Controller</b> means a natural person or a juristic person having the power and duties to make
          decisions regarding the collection, use, or disclosure of personal data.
          <br>

          - <b>Data Processor </b>
          means a natural person or a juristic person who operates in relation to the collection, use, or disclosure of
          personal data pursuant to the orders given by or on behalf of a data controller, whereas a person or juristic
          person who operates in such manner is not a data controller.
          <br>
        </div>

        <div class="mb-3"><b>4. Sources of Personal Data Collected by S2</b></div>
        <div>S2 collects or obtains various types of personal data from the following sources:</div>
        <div class="mb-3">
          1) Personal data that S2 collects directly from the data subject through various service channels, such as
          during the application process, registration, surveys, or use of products, services, or other service channels
          controlled by S2, or when the data subject communicates with S2 at its office or through other contact
          channels controlled by S2.
          <br>

          2) Data that S2 collects from the data subject's use of websites, products, or other services under contract
          or mission, such as tracking application usage behavior, products or services of S2 through the use of
          cookies, personal customized settings (e.g. watchlists, technical chart settings, alert settings) or from
          software on the data subject's device.
          <br>

          3) Personal data that S2 collects from sources other than the data subject, where such sources have the
          authority, legitimate reasons, or have obtained consent from the data subject to disclose the information to
          S2. Including but not limited to: <br>

          Necessary for providing services under contracts that may involve exchanging personal data with contractual
          partners.<br>

          Furthermore, this includes cases where you provide personal data of third parties to S2. In such cases, you
          are responsible for informing those individuals about the details in this policy or service-specific
          announcements, as applicable. You must also obtain consent from those individuals if required for disclosing
          their information to S2.<br><br>

          In cases where the data subject refuses to provide information necessary for S2's services, it may result in
          S2 being unable to provide all or part of its services to that data subject.
        </div>


        <div class="mb-3"><b>5. Purposes of Personal Data Collection</b></div>
        <div class="mb-3"> S2 determines the purposes for collecting your personal data based on appropriateness and the
          context of service provision. The purposes for which S2 collects personal data include:
        </div>
        <div class="container">
          <div class="row border border-dark">
            <div class="col border border-dark">
              <div class="text-center"><b>Purpose of Data Collection
              </b></div>
            </div>
            <div class="col border border-dark">
              <div class="text-center"><b>Details</b></div>
            </div>
          </div>
          <div class="row border border-dark">
            <div class="col border border-dark">
              <div>Necessary for legitimate interests</div>
            </div>
            <div class="col border border-dark">
              <div> For the legitimate interests of S2 and other individuals, where such interests are not less
                important than the fundamental rights to personal data of the data subject. For example:<br>

                - To maintain security of S2's premises <br>
                - To process personal data for S2's internal affairs, etc.
              </div>
            </div>
          </div>
          <div class="row border border-dark">
            <div class="col border border-dark">
              <div>To fulfill contractual obligations</div>
            </div>
            <div class="col border border-dark">
              <div> To enable S2 to perform its duties under a contract or to take necessary steps prior to entering
                into a contract to which you are a party with S2. For example:<br>

                - Memoranda of understanding or other forms of contracts, etc.
              </div>
            </div>
          </div>
          <div class="row border border-dark mb-3">
            <div class="col border border-dark">
              <div>Your consents</div>
            </div>
            <div class="col border border-dark">
              <div> For the collection, use, or disclosure of personal data in cases where S2 is required to obtain your
                consent, having already notified you of the purpose of such collection, use, or disclosure prior to
                requesting consent. Examples include the collection of sensitive personal data for purposes not falling
                under the exceptions in Section 24 or 26 of the Personal Data Protection Act B.E. 2562 (2019), or the
                presentation and promotion of products and services of contractual partners or business allies to you,
                among other instances.
              </div>
            </div>
          </div>
        </div>

        <div class="mb-3"> In cases where S2 needs to collect your personal data for the purpose of contract
          performance, compliance with legal obligations, or as necessary for entering into a contract, if you refuse to
          provide personal data or object to the processing for the purposes of the activity, S2 may be unable to fully
          or partially perform or provide the services you have requested.
        </div>

        <div class="mb-3"><b>6. Types of Personal Data Collected by S2</b></div>
        <div class="mb-3"> S2 may collect or obtain the following information, which may include your personal data.
          This
          depends on the services you use or the nature of your relationship with S2, as well as other considerations
          that affect the collection of personal data. The types of data listed below are just a general framework for
          S2's personal data collection. Only the information relevant to the products or services you use or have a
          relationship with will be applicable.
        </div>
        <div class="container">
          <div class="row border border-dark">
            <div class="col border border-dark">
              <div class="text-center"> Types of Personal Data</div>
            </div>
            <div class="col border border-dark">
              <div class="text-center"> Details
              </div>
            </div>
          </div>
          <div class="row border border-dark">
            <div class="col border border-dark">
              <div>Personal identification information</div>
            </div>
            <div class="col border border-dark">
              <div> Information that identifies you or data from official documents that specify your personal details,
                including but not limited to: title, first name, last name, nickname, and so on.
              </div>
            </div>
          </div>
          <div class="row border border-dark">
            <div class="col border border-dark">
              <div>Personal characteristic information</div>
            </div>
            <div class="col border border-dark">
              <div> Detailed information about you, including but not limited to: date of birth, gender, age, photos,
                and so on.
              </div>
            </div>
          </div>
          <div class="row border border-dark">
            <div class="col border border-dark">
              <div>Contact information</div>
            </div>
            <div class="col border border-dark">
              <div> Information for contacting you, including but not limited to: phone number, email address, and so
                on.
              </div>
            </div>
          </div>
          <div class="row border border-dark">
            <div class="col-6 border border-dark">
              <div>Information about the use of S2 services</div>
            </div>
            <div class="col-6 border border-dark">
              <div> Details about S2's products or services, including but not limited to: user account names,
                passwords, Single Sign-on (SSO ID) information, computer traffic data, photographs, usage behavior data
                (for application under S2's supervision such as https://stockradars.co or various devices), search
                history, cookies or similar technologies, device ID, device type, connection details, browser
                information, language used, operating system used, and so on.
              </div>
            </div>
          </div>
        </div>
        <div class="mb-3"><b>7. Cookies</b></div>
        <div class="mb-3"> S2 collects and uses cookies and other similar technologies on websites under S2's
          supervision, such as https://stockradars.co, or on your devices depending on the services you use. This is
          done to ensure security in providing S2's services and to provide you, as a user, with convenience and a good
          experience in using S2's services. This information will be used to improve S2's website to better meet your
          needs. You can set or delete cookie usage yourself through the settings in your web browser.
        </div>
        <div class="mb-3"><b>8. Personal data of minors, incompetent persons, and quasi-incompetent persons</b></div>
        <div class="mb-3"> In cases where S2 knows that personal data requiring consent for collection belongs to a data
          subject who is a minor, incompetent person, or quasi-incompetent person, S2 will not collect such personal
          data until consent is obtained from the person with parental authority, guardian, or curator, as the case may
          be, in accordance with legal conditions. In cases where S2 did not know beforehand that the data subject was a
          minor, incompetent person, or quasi-incompetent person, and later discovers that S2 has collected data of such
          data subjects without consent from the person with parental authority, guardian, or curator, as the case may
          be, S2 will promptly delete or destroy such personal data if S2 has no other legal basis apart from consent
          for collecting, using, or disclosing such data.
        </div>
        <div class="mb-3"><b>9. Purposes of personal data collection</b></div>
        <div class="mb-3">
          S2 collects your personal data for several purposes, depending on the type of products, services, or
          activities you use, as well as the nature of your relationship with S2 or considerations in each context. The
          purposes listed below are only a general framework for S2's use of personal data. Only the purposes relevant
          to the products or services you use or have a relationship with will be applicable to your data.<br><br>

          1). To carry out necessary actions in pursuing public interests assigned to S2 or as necessary to exercise
          legal authority that S2 has the duty to perform according to the mission as stated in the Royal Decree
          Establishing the Digital Government Development Agency (Public Organization) B.E. 2561 and related laws,
          rules, regulations, or orders.<br>
          2) To provide and manage S2's services, both services under contracts with you or according to S2's
          mission<br>
          3) For S2's business transactions.<br>
          4) To control, use, monitor, inspect, and manage services to facilitate and align with your needs.<br>
          5) To maintain and improve information related to you, including documents that reference you.<br>
          6) To create records of personal data processing as required by law.<br>
          7) To analyze data and solve problems related to S2's services.<br>
          8) To carry out necessary actions in internal organizational management, including job recruitment, selection
          of board members or various position holders, and qualification assessment.<br>
          9) To prevent, detect, avoid, and investigate fraud, security breaches, or prohibited or illegal actions that
          may cause damage to both S2 and personal data owners.<br>
          10) For identity verification, authentication, and information checking when you apply for S2's services,
          contact for services, or exercise legal rights.<br>
          11) To improve and develop the quality of products and services to be up-to-date.<br>
          12) For risk assessment and management.<br>
          13) To send notifications, confirm orders, communicate, and inform you of news.<br>
          14) To prepare and deliver relevant and necessary documents or information.<br>
          15) To verify identity, prevent spam or unauthorized or illegal actions.<br>
          16) To check how personal data owners access and use S2's services, both overall and individually, and for
          research and analysis purposes.<br>
          17) To carry out necessary actions to comply with S2's obligations to regulatory authorities, tax authorities,
          law enforcement, or S2's legal obligations.<br>
          18) To carry out necessary actions for the legitimate interests of S2 or other individuals or legal entities
          related to the operations of the Digital Government Development Agency (Public Organization) or DGA.<br>
          19) To prevent or stop dangers to life, body, or health of individuals, including epidemic surveillance.<br>
          20) To prepare historical documents for public benefit, research, or statistics that S2 is assigned to
          conduct.<br>
          21) To comply with laws, announcements, enforceable orders, or to conduct legal proceedings, handle data
          according to court orders, including exercising rights related to your data.
          <br></div>

        <div class="mb-3"><b>10. Categories of Persons to Whom S2 Discloses Your Personal Data</b></div>
        <div class="mb-3"> Under the purposes specified in Section 9 above, S2 may disclose your personal data to the
          following persons. The categories of data recipients listed below constitute only a general framework for S2's
          personal data disclosure. Only data recipients relevant to the products or services you use or have a
          relationship with will be applicable.
        </div>

        <div class="container mb-3">
          <div class="row border border-dark">
            <div class="col border border-dark">
              <div class="text-center"><b>Categories of Data Recipients

              </b></div>
            </div>
            <div class="col border border-dark">
              <div class="text-center"><b>Details</b></div>
            </div>
          </div>
          <div class="row border border-dark">
            <div class="col border border-dark">
              <div>Government agencies or competent authorities to whom S2 must disclose information for the purposes of
                legal compliance or other important objectives (such as operations for public interest)
              </div>
            </div>
            <div class="col border border-dark">
              <div> Law enforcement agencies, regulatory authorities, or entities with other significant purposes, such
                as the Cabinet, the Minister in charge, Department of Provincial Administration, Revenue Department,
                Royal Thai Police, Courts, Office of the Attorney General, Department of Disease Control, Ministry of
                Digital Economy and Society, Office of the Permanent Secretary to the Prime Minister's Office,
                Department of Consular Affairs, Student Loan Fund, among others
              </div>
            </div>
          </div>
          <div class="row border border-dark">
            <div class="col border border-dark">
              <div> Various committees related to S2's legal operations</div>
            </div>
            <div class="col border border-dark">
              <div> S2 may disclose your information to individuals holding positions as committee members in various
                committees, such as the Recruitment Subcommittee, the Board of Digital Government Development Agency,
                among others
              </div>
            </div>
          </div>
          <div class="row border border-dark">
            <div class="col border border-dark">
              <div> Contractual partners who manage welfare benefits for S2's employees</div>
            </div>
            <div class="col border border-dark">
              <div> External parties contracted by S2 to manage welfare benefits, such as insurance companies,
                hospitals, payroll service providers, banks, telephone service providers, among others
              </div>
            </div>
          </div>
          <div class="row border border-dark">
            <div class="col border border-dark">
              <div>Business partners</div>
            </div>
            <div class="col border border-dark">
              <div>S2 may disclose your information to individuals collaborating with S2 for the benefit of providing
                services to you, such as service providers you contact through S2's services, marketing service
                providers, advertising media, financial institutions, platform service providers, telecommunications
                service providers, among others
              </div>
            </div>
          </div>
          <div class="row border border-dark">
            <div class="col border border-dark">
              <div>Service providers</div>
            </div>
            <div class="col border border-dark">
              <div> S2 may assign other parties to provide services on its behalf or support S2's operations, such as
                data storage service providers (e.g., cloud services, document warehouses), system developers, software
                developers, application developers, website developers, document delivery service providers, payment
                service providers, internet service providers, telephone service providers, Digital ID service
                providers, social media service providers, risk management service providers, external consultants,
                transportation service providers, among others
              </div>
            </div>
          </div>
          <div class="row border border-dark">
            <div class="col border border-dark">
              <div>Other types of data recipients

              </div>
            </div>
            <div class="col border border-dark">
              <div> S2 may disclose your information to other types of data recipients, such as individuals contacting
                S2, family members, non-profit foundations, temples, hospitals, educational institutions, or other
                organizations. This is for purposes related to S2's services, training, receiving awards, participating
                in merit-making activities, donations, among others.
              </div>
            </div>
          </div>
          <div class="row border border-dark">
            <div class="col border border-dark">
              <div>Public disclosure of information
              </div>
            </div>
            <div class="col border border-dark">
              <div> S2 may publicly disclose your information when necessary, such as in cases where S2 is required to
                publish announcements in the Royal Gazette or by Cabinet resolution, among others.
              </div>
            </div>
          </div>
        </div>

        <div class="mb-3"><b>11. Cross-border transfer of personal data</b></div>
        <div> In some cases, S2 may need to transfer your personal data to foreign countries to fulfill the purposes of
          providing services to you, such as sending personal data to cloud systems with platforms or servers located
          abroad (e.g., in Singapore or the United States) to support information technology systems located outside
          Thailand. This depends on the S2 services you use or are involved with on a case-by-case basis.
        </div>
        <div class="mb-3"> However, at the time of drafting this policy, the Personal Data Protection Committee has not
          yet announced a list of destination countries with adequate personal data protection standards. Therefore,
          when S2 needs to send or transfer your personal data to a destination country, S2 will take measures to ensure
          that the personal data transferred has adequate protection measures according to international standards or
          will operate under conditions that allow such data to be sent or transferred legally, including:
        </div>
        <div class="mb-3">
          1) Compliance with laws that require S2 to send or transfer personal data abroad<br>
          2) Notifying you and obtaining your consent in cases where the destination country has inadequate personal
          data protection standards, as per the list of countries announced by the Personal Data Protection
          Committee<br>
          3) It is necessary for the performance of a contract to which you are a party with S2 or to take steps at your
          request prior to entering into a contract<br>
          4) It is to comply with a contract between S2 and other persons or juristic persons for your benefit<br>
          5) To prevent or suppress danger to your life, body, or health, or that of other persons, when you are
          incapable of giving consent at that time<br>
          6) It is necessary for carrying out activities for substantial public interest<br>
        </div>
        <div class="mb-3"><b>12. Retention period of your personal data
        </b></div>
        <div class="mb-3"> S2 will retain your personal data for as long as it is necessary for the purposes for which
          it was collected, as detailed in the policy, announcements, or as required by relevant laws. When the
          retention period has expired and your personal data is no longer necessary for the aforementioned purposes, S2
          will delete, destroy your personal data, or render your personal data unidentifiable, in accordance with the
          form and standards of deletion and destruction of personal data that the Committee or the law will announce or
          according to international standards. However, in the event of a dispute, exercise of rights, or legal
          proceedings related to your personal data, S2 reserves the right to retain such data until the dispute is
          resolved or a final court order or judgment is issued.
        </div>
        <div class="mb-3"><b>13. Services provided by third parties or sub-processors</b></div>
        <div class="mb-3"> S2 may assign or procure third parties (personal data processors) to process personal data on
          behalf of or in the name of S2. These third parties may offer services in various forms, such as being a host,
          cloud computing service/provider, or other forms of contracted work.
          <br><br>

          When assigning third parties to process personal data as personal data processors, S2 will arrange for an
          agreement specifying the rights and duties of S2 as the personal data controller and of the person assigned by
          S2 as the personal data processor. This includes specifying details of the types of personal data that S2
          assigns for processing, as well as the purposes, scope of personal data processing, and other relevant
          agreements. The personal data processor has the duty to process personal data only within the scope specified
          in the agreement and according to S2's instructions, and cannot process for other purposes.
          <br><br>
          In cases where the personal data processor assigns sub-processors to process personal data on behalf of or in
          the name of the personal data processor, S2 will supervise the personal data processor to arrange for an
          agreement between the personal data processor and the sub-processor in a form and standard no less than the
          agreement between S2 and the personal data processor.
        </div>

        <div class="mb-3"><b>14. Security of personal data</b></div>
        <div class="mb-3"> S2 has measures to protect personal data by limiting access rights to personal data to be
          accessible only by specific officers or authorized persons or assignees who need to use such data, according
          to the purposes notified to the personal data owner. Such persons must adhere to and strictly comply with S2's
          personal data protection measures, as well as have a duty to maintain the confidentiality of personal data
          that they become aware of from performing their duties. S2 has organizational and technical security measures
          that meet international standards and comply with what the Personal Data Protection Committee announces.
        </div>
        <div class="mb-3"> Furthermore, when S2 sends, transfers, or discloses personal data to third parties, whether
          for service provision according to the mission, contract, or other forms of agreement, S2 will specify
          appropriate personal data security measures and confidentiality maintenance that comply with the law, to
          confirm that the personal data collected by S2 will always be secure.
        </div>
        <div class="mb-3"><b>15. Connection to external websites or services
        </b></div>
        <div class="mb-3"> S2's services may connect to third-party websites or services, which may have personal data
          protection policies with different content from this policy. S2 recommends that you study the personal data
          protection policy of those websites or services for details before use. S2 is not associated with and has no
          control over the personal data protection measures of such websites or services, and cannot be responsible for
          the content, policies, damages, or actions arising from third-party websites or services.
        </div>

        <div class="mb-3"><b>16. Data Protection Officer</b></div>
        <div class="mb-3"> S2 has appointed a Data Protection Officer to inspect, supervise, and provide advice on the
          collection, use, or disclosure of personal data, including coordinating and cooperating with the Office of the
          Personal Data Protection Committee, to comply with the Personal Data Protection Act B.E. 2562 (2019).
        </div>
        <div class="mb-3"><b>17. Your rights under the Personal Data Protection Act B.E. 2562 (2019)</b></div>
        <div class="mb-3"> The Personal Data Protection Act B.E. 2562 (2019) has stipulated several rights of personal
          data owners. These rights will come into effect when the law in this part becomes effective. The details of
          various rights include:
        </div>
        <div class="mb-3">1) Right to access personal data: You have the right to access, obtain a copy, and request
          disclosure of the source of your personal data that S2 has collected without your consent, unless S2 has the
          right to reject your request for legal reasons or court orders, or if exercising your right may affect and
          cause damage to the rights and freedoms of others.
        </div>
        <div class="mb-3">2) Right to rectify personal data to be accurate, up-to-date, and complete: If you find that
          your personal data is inaccurate, incomplete, or not up-to-date, you have the right to request corrections to
          make it accurate, up-to-date, complete, and not misleading.
        </div>
        <div class="mb-3">3) Right to delete or destroy personal data: You have the right to request S2 to delete or
          destroy your personal data, or make your personal data non-identifiable. However, exercising this right to
          delete or destroy personal data must be subject to the conditions prescribed by law. You can request directly
          to us via our contact channels on 21. Inquiries or Exercise of Rights.
        </div>
        <div class="mb-3">4) Right to restrict the use of personal data: You have the right to restrict the use of your
          personal data in the following cases: <br>
          a) When S2 is in the process of verifying the accuracy of personal data as requested by the personal data
          owner<br>
          b) When the personal data has been collected, used, or disclosed unlawfully<br>
          c) c) When the personal data is no longer necessary to be retained for the purposes S2 has notified in the
          collection, but the personal data owner wishes S2 to retain this information for the purpose of establishing
          legal claims <br>
          d) When S2 is in the process of proving legitimate grounds for collecting personal data of the personal data
          owner, or checking the necessity of collecting, using, or disclosing personal data for public interest
          purposes, due to the personal data owner exercising the right to object to the collection, use, or disclosure
          of personal data
        </div>

        <div class="mb-3">5) Right to object to the processing of personal data: You have the right to object to the
          collection, use, or disclosure of personal data related to you, unless S2 has legitimate grounds to reject
          your request (e.g., S2 can demonstrate that the collection, use, or disclosure of your personal data has more
          legitimate grounds, or for the establishment of legal claims, compliance with or exercise of legal claims, or
          for S2's public interest).
        </div>
        <div class="mb-3">6) Right to withdraw consent: In cases where you have given consent to S2 for the collection,
          use, or disclosure of personal data (whether such consent was given before or after the Personal Data
          Protection Act B.E. 2562 (2019) came into effect), you have the right to withdraw consent at any time
          throughout the period that S2 retains your personal data, unless there are legal restrictions requiring S2 to
          retain the data, or there is still a contract between you and S2 that benefits you.
        </div>
        <div class="mb-3">7) Right to data portability: You have the right to receive your personal data from S2 in a
          format that is readable or commonly usable by automatic tools or equipment, and can be used or disclosed by
          automatic methods. You may also request S2 to send or transfer such data in the aforementioned format to other
          personal data controllers. However, exercising this right must be subject to the conditions prescribed by law.
        </div>

        <div class="mb-3"><b>18. Penalties for non-compliance with the personal data protection policy</b></div>
        <div class="mb-3"> Failure to comply with the policy may result in disciplinary action and penalties according
          to S2's rules (for S2 officers or operators) or according to the personal data processing agreement (for
          personal data processors), depending on the case and your relationship with S2, and may be subject to
          penalties as stipulated by the Personal Data Protection Act B.E. 2562 (2019), as well as subordinate
          legislation, rules, regulations, and related orders.
        </div>
        <div class="mb-3"><b>19. Complaints to the Supervisory Authority</b></div>
        <div class="mb-3"> In the event that you find S2 is not complying with personal data protection laws, you have
          the right to file a complaint with the Personal Data Protection Committee or a supervisory authority appointed
          by the Personal Data Protection Committee or by law. However, before filing such a complaint, S2 requests that
          you please contact S2 first to allow S2 the opportunity to acknowledge the facts, provide explanations on
          various issues, and address your concerns at the earliest opportunity.
        </div>
        <div class="mb-3"><b>20. Amendments to the Personal Data Protection Policy
        </b></div>
        <div class="mb-3"> S2 may consider improving, amending, or changing this policy as deemed appropriate and will
          notify you through the website https://stockradars.co, with the effective date of each amended version
          indicated. However, S2 recommends that you regularly check for updates to the policy through the application
          or specific channels where S2 operates, especially before disclosing personal data to S2. Using S2's products
          or services after the new policy takes effect is considered acknowledgment of the terms in the new policy. If
          you disagree with the details in this policy, please discontinue use and contact S2 for further clarification
          of the facts.
        </div>
        <div class="mb-3"><b>21. Inquiries or Exercise of Rights
        </b></div>
        <div> If you have any questions, suggestions, or concerns about S2's collection, use, and disclosure of personal
          data, or if you wish to exercise your rights under personal data protection law, including requesting the
          deletion of your personal data collected by the app, you can contact:
        </div>
        <div><b>1) Data Controller </b></div>
        <div>
          - Name: Siamsquared Technologies (Thailand) Co., Ltd.<br>
          - Contact Address: 23/69-71, RCA Block G, Rama 9 Road, Bang Kapi Subdistrict, Huai Khwang District, Bangkok
          10310
          <br>
          - Contact Channels: dpo@siamsquared.com Call Center: 092 249 4999
        </div>

        <div><b>2) Data Protection Officer (DPO)</b></div>
        <div class="mb-3">
          - Name: Siamsquared Technologies (Thailand) Co., Ltd.<br>
          - Contact Address: 23/69-71, RCA Block G, Rama 9 Road, Bang Kapi Subdistrict, Huai Khwang District, Bangkok
          10310
          <br>
          - Contact Channels: dpo@siamsquared.com Call Center: 092 249 4999
        </div>

        <div class="mb-3"> To request the deletion of your personal data, please adhere to the following process:</div>


        <div class="mb-3"> Submission of Request: <br>
          Send an email to dpo@siamsquared.com with the subject line "Data Deletion Request," or contact us by phone at
          +66 92 249 4999.
        </div>


        <div class="mb-3"> Required Information: <br>
          In your request, please provide your account ID, email address, and a detailed description of the data you
          wish to have deleted. We may need to request additional information to verify your identity and process your
          request.
        </div>


        <div class="mb-5"> Processing Timeframe: <br>
          We will process your data deletion request within 30 days of receipt. You will receive confirmation of the
          deletion via email. If further information is needed to fulfill your request, we will contact you within this
          period.
        </div>


        <div class="mb-3 text-center">Update Date: 8 August 2024</div>
      </div>
    </div>

  </div>


</template>

<script>
import AccountTabMenu from "@/views/PrivacyPolicy/Menu";

export default {
  components: {AccountTabMenu},
  data() {
    return {lang: "th"}
  },
  created() {
    let {lang} = this.$route.query;
    this.lang = lang || 'en';
  },
  methods: {
    changeLanguage(lang) {
      this.lang = lang || 'th';
    }
  }
};
</script>
